import React from 'react'
import { withIdentity } from '#src/containers/Identity'
import hoistNonReactStatic from 'hoist-non-react-statics'
import { WithIdentityProps } from './withIdentity'
import { Unauthorized } from '#src/components/Errors'
import omit from 'lodash/omit'

function getDisplayName(WrappedComponent: React.ComponentType<any>) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component'
}

export default function withAuthentication<P>(WrappedComponent: React.ComponentType<P>) {
  const WithAuthentication: React.SFC<WithIdentityProps & P> = props => {
    // Only expose the props that were passed in. These are created and used only by this HOC:
    const passthroughProps = omit(props, 'myself', 'userId', 'sessionId', 'refetchIdentity')

    if (props.myself) {
      return <WrappedComponent {...passthroughProps as P} />
    } else {
      return <Unauthorized />
    }
  }

  WithAuthentication.displayName = `WithAuthentication(${getDisplayName(WrappedComponent)})`

  return hoistNonReactStatic(withIdentity<P>(WithAuthentication), WrappedComponent)
}
